<template>
  <div class="categories-horizontal-filter">
    <v-btn
      class="mb-2 categories-horizontal-filter_item categories-horizontal-filter_item__first"
      large
      :color="getBtnColor(0)"
      @click.prevent="setValue(0)"
    >
      Все
    </v-btn>

    <v-btn
      v-for="cat in categories"
      :key="`cat-${cat.id}`"
      :color="getBtnColor(cat.id)"
      class="mb-2 categories-horizontal-filter_item"
      large
      @click.prevent="setValue(cat.id)"
    >
      {{ cat.name }}
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'CategoriesHorizontalFilter',
    props: {
      value: {
        type: Number,
        default: 0,
      },
      categories: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      getBtnColor (catId) {
        return catId === this.value ? 'primary' : '#fff'
      },
      setValue (catId) {
        this.$emit('input', catId)
      },
    },
  }
</script>

<style scoped lang="less">
.categories-horizontal-filter {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;

  &_item {
    margin-right: 10px;
    /*box-shadow: 0 2px 2px #00000029; */
    //border:  1px solid rgba(0, 0, 0, 0.2) !important;
    //box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.2);
    box-shadow: 0 3px 6px #00000029;
    border-radius: 0 10px 0 10px;

    @media (max-width: 1500px) {
      padding: 0 15px !important;
      min-width: 80px !important;
    }

    &__first {
    }

    &:last-child {
      margin-right: 0;
    }

    .media-sm({
      min-width: 30%;
      flex-grow: 1;

      &:last-child {
        margin-right: 10px;
      }
    });
  }
}
</style>
